import React, { useState, useEffect } from "react";
import { SendRecoverEmail } from "../../../api/UserApi";
import ForgotPageForm from "./ForgotPageForm";
import { Button, Form, notification } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import AdnMessageError from "../../common/adnMessage/AdnMessageError";

function ManageForgotPage() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleForgot = (email) => {
    setLoading(true);
    SendRecoverEmail(email)
      .then((res) => {
        setLoading(false);
        notification.open({
          message: "Email Sent",
          description: "Please check your email to change your password.",
          icon: <SmileOutlined style={{ color: "#108ee9" }} />,
        });
      })
      .catch((err) => {
        setLoading(false);
        if (err.response.status == 400) {
          form.setFields([
            {
              name: "email",
              errors: ["Email does not exist"],
            },
          ]);
          return;
        }
        AdnMessageError();
      });
  };

  return (
    <div>
      <ForgotPageForm
        handleForgot={handleForgot}
        form={form}
        loading={loading}
      />
    </div>
  );
}

export default ManageForgotPage;
